/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { CARD_TAG_NAME, CardComponent } from './card';
export * from './card-constants';
export * from './card';
export function defineCardComponent() {
    tryDefine(CARD_TAG_NAME, CardComponent);
}
